import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import React, { FC } from 'react';
import StoreKPIReportDownloadInterface from '../../../models/TenantReports/StoreKPIReportDownload';
import TableBodyLoader from '../../../shared/components/TableBodyLoader/TableBodyLoader';
import TableFooter from '../../../shared/components/TableFooter/TableFooter';
import TableHeader from '../../../shared/components/TableHeader/TableHeader';
import formatDate from '../../../shared/utils/formatDate';
import Chip from '../../../shared/components/Chip/Chip';
import { GetApp } from '@material-ui/icons';
import config from '../../../config';
import { get, isNull } from 'lodash';
import moment from 'moment';

interface StoreKPIReportDownloadTableProps {
  reports: StoreKPIReportDownloadInterface[];
  isLoading: boolean;
  page: number;
  offset: number;
  setPage: (page: number) => void;
  setOffset: (offset: number) => void;
}

const headings = [
  'S.No',
  'Date Triggered',
  'Chosen Date',
  'Selected Store',
  'Status',
  'Download'
];

const StoreKPIReportDownloadTable: FC<StoreKPIReportDownloadTableProps> = props => {
  const { reports, isLoading, page, offset, setPage, setOffset } = props;
  const getDownloadReportUrl = (url: string): string => {
    if (isNull(url)) {
      return '';
    }
    const indexOfReportUrl = url.indexOf('/report') + 1;

    return `${config.ruleServerUrl}/download-file/${url.slice(
      indexOfReportUrl
    )}`;
  };
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHeader headings={headings} align="center" />
        {isLoading ? (
          <TableBodyLoader colSpan={headings.length} rowsPerPage={offset} />
        ) : (
          <TableBody>
            {reports.map((report, index) => (
              <TableRow key={report.id}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  {formatDate(report.createdAt)}
                </TableCell>
                <TableCell align="center">
                  {`${report.data.monthCount} months up-to ${moment(
                    report.data.endDate
                  ).format('YYYY-MMM-DD')}`}
                </TableCell>
                <TableCell align="center">
                  {get(report, 'data.storeName')}
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={report.status}
                    color={
                      report.status === 'COMPLETED'
                        ? 'success'
                        : report.status === 'FAILED'
                        ? 'error'
                        : 'primary-light'
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    disabled={report.status !== 'COMPLETED'}
                    component="a"
                    href={getDownloadReportUrl(report.errorFileLocation)}
                    download
                  >
                    <GetApp />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
        <TableFooter
          colSpan={headings.length}
          count={-1}
          page={page}
          rowsPerPage={offset}
          onPageChange={setPage}
          onRowPerPageChange={setOffset}
        />
      </Table>
    </TableContainer>
  );
};

export default StoreKPIReportDownloadTable;
